<div class="iframe-modal-shell">
  <div class="iframe-modal-shell__header">
    <div class="iframe-modal-shell__title">{{ title() }}</div>
    <button type="button" class="iframe-modal-shell__close" (click)="close.emit()" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>

  <div #contentArea class="iframe-modal-shell__content" [style.height.px]="iframeHeight()">
    @if (loading()) {
    <div class="iframe-modal-shell__loading">
      <span class="iframe-modal-shell__dot"></span>
      <span class="iframe-modal-shell__dot"></span>
      <span class="iframe-modal-shell__dot"></span>
    </div>
    }

    @if (src()) {
    <iframe
      #iframe
      class="iframe-modal-shell__iframe"
      frameborder="0"
      scrolling="auto"
      allow="camera; microphone; display-capture; clipboard-write; fullscreen; autoplay"
      allowfullscreen
      [src]="src()"
      (load)="onIframeLoad()"
    >
    </iframe>
    }
  </div>
</div>
